import React from 'react'
import { Link } from 'react-router-dom'
import '../eventsTabs/EventTab.css'

const EventTab = () => {
  return (
    <div className='events-tabs-sec'>
        <div className='inner-events-tabs mb-5'>
            <h6>Monday, 12 October</h6>
            <div className='card-box'>
                <div className='inner-card-events d-flex flex-wrap'>
                    <div className='left-card-events'>
                        <h2>Buck’s Party</h2>
                        <h3>Strippers</h3>
                        <p>12pm - 2pm (2h)</p>
                        <p>12 Honoy st, South Melbourne VIC</p>
                        <form action="">
                            <div className='form-group'>
                                <textarea name="" cols="4" rows="3" id="" placeholder='Description'></textarea>
                            </div>
                            <span className='text-pink'>Messages</span>
                            <div className='form-group'>
                                <input type="text" className="form-control" id="" placeholder="Message" />
                            </div>
                        </form>
                    </div>
                    <div className='right-card-events'>
                        <ul className='d-flex flex-wrap justify-content-md-end'>
                            <li>
                                <Link rel='stylesheet' className='btn btn-border top-btn btn-active d-flex align-items-center justify-content-center'>
                                    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.77845 9.96415C8.68262 9.95498 8.56762 9.95498 8.4622 9.96415C6.18137 9.89081 4.37012 8.10331 4.37012 5.90331C4.37012 3.65748 6.26762 1.83331 8.62512 1.83331C10.973 1.83331 12.8801 3.65748 12.8801 5.90331C12.8705 8.10331 11.0593 9.89081 8.77845 9.96415Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.7261 3.66669C17.5853 3.66669 19.0803 5.10585 19.0803 6.87502C19.0803 8.60752 17.6428 10.0192 15.8507 10.0834C15.7741 10.0742 15.6878 10.0742 15.6016 10.0834" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.98645 13.3467C1.66728 14.8317 1.66728 17.2517 3.98645 18.7275C6.62186 20.4142 10.9439 20.4142 13.5794 18.7275C15.8985 17.2425 15.8985 14.8225 13.5794 13.3467C10.9535 11.6692 6.63145 11.6692 3.98645 13.3467Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5762 18.3333C18.2662 18.1958 18.9178 17.93 19.4545 17.5358C20.9495 16.4633 20.9495 14.6941 19.4545 13.6216C18.9274 13.2366 18.2853 12.98 17.6049 12.8333" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                    Private
                                </Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' className='btn btn-border d-flex align-items-center justify-content-center'>Requests <span>(12)</span> </Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' className='btn btn-border d-flex align-items-center justify-content-center'>Approved <span>(2)</span> </Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' className='btn btn-border'>Cancel</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className='inner-events-tabs'>
            <h6>Monday, 12 October</h6>
            <div className='card-box'>
                <div className='inner-card-events d-flex flex-wrap'>
                    <div className='left-card-events'>
                        <h2>Topless Waitressing</h2>
                        <h3>Strippers</h3>
                        <p>12pm - 2pm (2h)</p>
                        <p>12 Honoy st, South Melbourne VIC</p>
                        <form action="">
                            <div className='form-group'>
                                <textarea name="" cols="4" rows="3" id="" placeholder='Description'></textarea>
                            </div>
                            <span className='text-pink'>Messages</span>
                            <div className='form-group'>
                                <input type="text" className="form-control" id="" placeholder="Message" />
                            </div>
                        </form>
                    </div>
                    <div className='right-card-events'>
                        <ul className='d-flex flex-wrap justify-content-md-end'>
                            <li>
                                <Link rel='stylesheet' className='btn btn-border top-btn d-flex align-items-center justify-content-center'>
                                    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.77845 9.96415C8.68262 9.95498 8.56762 9.95498 8.4622 9.96415C6.18137 9.89081 4.37012 8.10331 4.37012 5.90331C4.37012 3.65748 6.26762 1.83331 8.62512 1.83331C10.973 1.83331 12.8801 3.65748 12.8801 5.90331C12.8705 8.10331 11.0593 9.89081 8.77845 9.96415Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.7261 3.66669C17.5853 3.66669 19.0803 5.10585 19.0803 6.87502C19.0803 8.60752 17.6428 10.0192 15.8507 10.0834C15.7741 10.0742 15.6878 10.0742 15.6016 10.0834" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.98645 13.3467C1.66728 14.8317 1.66728 17.2517 3.98645 18.7275C6.62186 20.4142 10.9439 20.4142 13.5794 18.7275C15.8985 17.2425 15.8985 14.8225 13.5794 13.3467C10.9535 11.6692 6.63145 11.6692 3.98645 13.3467Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5762 18.3333C18.2662 18.1958 18.9178 17.93 19.4545 17.5358C20.9495 16.4633 20.9495 14.6941 19.4545 13.6216C18.9274 13.2366 18.2853 12.98 17.6049 12.8333" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                    Public
                                </Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' className='btn btn-border d-flex align-items-center justify-content-center'>Requests <span>(12)</span> </Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' className='btn btn-border d-flex align-items-center justify-content-center'>Approved <span>(2)</span> </Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' className='btn btn-border'>Cancel</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EventTab
